import _ from 'lodash'
import { validateTemplate } from './templateValidator'
import { TemplateAPI } from '../api/TemplateAPI'
import { TEMPLATE_TYPES, TEMPLATE_TYPE_CODES } from '../consts'

export const validateSchedulerFields = (data) => {
    let errorFields = []
    Object.keys(data).forEach((key) => {
        if (key === 'caption') {
            const networks = data['publishTo']
            const canSkip =
                !_.isEmpty(networks) &&
                networks.length === 1 &&
                networks[0].canonicalName === 'instagram_story'
            if (canSkip) {
                return
            }
        }

        if (data[key] == null || data[key].length == 0) {
            errorFields.push(key)
        }
    })
    return errorFields
}

export const mapBlogFields = (blog) => {
    return {
        'blog.title': blog.title,
        'blog.text': blog.text,
        'blog.cover_image': blog.cover_image,
    }
}

export const mapListingFields = (listing) => {
    return {
        'listing.title': listing.title,
        'listing.text': listing.text,
        'listing.cover_image': listing.cover_image,
        'listing.price': listing.price,
    }
}

export const TEMPLATE_EDITOR_FUNC_MAP = {
    QUOTE: {
        validate: (canvasJSON) =>
            validateTemplate(canvasJSON, TEMPLATE_TYPES.QUOTE),
        update: (id, title, blob, canvasJSON) =>
            TemplateAPI.update(
                id,
                title,
                blob,
                canvasJSON,
                TEMPLATE_TYPE_CODES.TEXT
            ),
        submit: (title, blob, canvasJSON) =>
            TemplateAPI.create(
                title,
                blob,
                canvasJSON,
                TEMPLATE_TYPE_CODES.TEXT
            ),
    },
    BLOG: {
        validate: (canvasJSON) =>
            validateTemplate(canvasJSON, TEMPLATE_TYPES.BLOG),
        update: (id, title, blob, canvasJSON) =>
            TemplateAPI.update(
                id,
                title,
                blob,
                canvasJSON,
                TEMPLATE_TYPE_CODES.BLOG
            ),
        submit: (title, blob, canvasJSON) =>
            TemplateAPI.create(
                title,
                blob,
                canvasJSON,
                TEMPLATE_TYPE_CODES.BLOG
            ),
    },
    LISTING: {
        validate: (canvasJSON) =>
            validateTemplate(canvasJSON, TEMPLATE_TYPES.LISTING),
        update: (id, title, blob, canvasJSON) =>
            TemplateAPI.update(
                id,
                title,
                blob,
                canvasJSON,
                TEMPLATE_TYPE_CODES.LISTING
            ),
        submit: (title, blob, canvasJSON) =>
            TemplateAPI.create(
                title,
                blob,
                canvasJSON,
                TEMPLATE_TYPE_CODES.LISTING
            ),
    },
}
